module.exports = __webpack_public_path__ + "static/media/Eye(R) v1.7fef8a53.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/Eye(R) v1.jpg
// module id = 406
// module chunks = 0